import { useApi } from "hooks"
import { useQuery } from '@tanstack/react-query'

const useGetByCategory = ({
  categoryId,
  contentType,
  filter = (item) => item
}) => {

  const { apiFetch } = useApi();
  const url = `/contents/top/bycategory/${categoryId}?contentType=${contentType}`

  const getByCategory = () => {
    return apiFetch({ url })
      .then( res => res.data.contents)
  }

  const options = {
    staleTime: 60000 * 30, // 30 min
    placeholderData: null,
    enabled: !!categoryId && !!contentType
  }

  const {
    data,
    ...rest
  } = useQuery(['contentByCategory', categoryId, contentType], getByCategory, options)

  return {
    data: data?.filter(filter),
    ...rest
  }
}

export default useGetByCategory
